// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"453cb7d2","453":"688964a4","455":"36651742","977":"08c58c0b"}[chunkId] + ".chunk.js";
};